import { Logger, LoggerService } from '@Shared/logger';
import { Screen } from './screen.base';
import { OptionsModule } from '@Modules/options_module';
import { UIModule } from '@Modules/ui_module/ui.module';
import { Alert } from '@Modules/ui_module/components/alert/alert.component';

export class PreAuthCheckScreen extends Screen {
  private Logger: Logger = LoggerService.createLogger('PreAuthCheckScreen');

  constructor() {
    super();
    this.Logger.trace('****  CTOR ****');

    this._html = UIModule.HTML.loadingModal;
    this._screenOptions = OptionsModule.Options.ui.screens.preAuthCheck;
    this._alert = new Alert();
  }

  show(): void {
    super.show();
    const loadingScreenText = document.querySelector(
      '.mng-loading-modal-screen-text',
    );
    if (loadingScreenText) {
      loadingScreenText.textContent =
        this._screenOptions.html || 'Processing...';
    }
    this.Logger.trace('show called');
  }
}
